import React from "react";

export function Elections() {
    return (
        <>
        
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        <center>
        <div class="right2">
<h1>Previous Fire Election Results</h1>
<hr />
<ul>
         <li><a href="https://diuy0t6boke2n.cloudfront.net/FD%231+2026+Fire+Election+Results.docx"><button>2026 Fire District Election Results</button></a></li>
     <li><a href="https://diuy0t6boke2n.cloudfront.net/FD%231+Election+Results+2025.docx"><button>2025 Fire District Election Results</button></a></li>
<li><a href="https://diuy0t6boke2n.cloudfront.net/2024_Fire_Election_Results%20(2).docx" target="new">2024 Fire Election Results</a></li>
	<li><a href="https://diuy0t6boke2n.cloudfront.net/2023_Fire_Election_Results.pdf" target="new">2023 Fire Election Results</a></li>
	<li><a href="https://diuy0t6boke2n.cloudfront.net/2022_Election Results.docx" target="new">2022 Fire Election Results</a></li>
	<li><a href="https://diuy0t6boke2n.cloudfront.net/2021_Election_Results.docx" target="new">2021 Fire Election Results</a></li>
<li><a href="https://diuy0t6boke2n.cloudfront.net/2020_FIRE_ELECTION_RESULTS.docx" target="new">2020 Fire Election Results</a></li>
<li><a href="https://diuy0t6boke2n.cloudfront.net/2019_Election_Results.pdf" target="new">2019 Fire Election Results</a>
</li>
<li><a href="https://diuy0t6boke2n.cloudfront.net/2018_Election_results.docx" target="new">2018 Fire Election Results</a></li>
<li><a href="https://diuy0t6boke2n.cloudfront.net/2017_Election_Results.pdf" target="new">2017 Fire Election Results</a></li>
<li><a href="https://diuy0t6boke2n.cloudfront.net/2016_ELECTION_RESULTS.docx" target="new">2016 Fire Election Results</a></li>
</ul>
</div>
        </center>
        </>
    )
}